import { Component, OnInit } from '@angular/core';
import { CrudService } from '../../../crud/crud.service';

import { NotificationsService } from 'angular2-notifications';

import { Mensaje } from "../../../mensaje";

import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable';
import * as jQuery from 'jquery';
import * as moment from 'moment';
@Component({
  selector: 'app-periodo-escolar-lista',
  templateUrl: './lista.component.html'
})

export class ListaComponent{
  tamano = document.body.clientHeight;

  detalles: any = "";

  carreras_planes_id;
  periodos_escolares_id;
  nivel;
  filtro;
  fNombreGrupo;
  grupos_id;
  nombreGrupo;

  dato = [];
  item;
  documentos = [];
  cargando = false;
  borrarCargando: boolean = false;
  baja: boolean = true;

  mensajeResponse: Mensaje = new Mensaje(true);

  logo_sucursal = "";
  logo_empresa = "";
  logo_carrera = "";
  public options = {
    position: ["middle", "center"],
    timeOut: 3000,
    lastOnBottom: true
  };

  datos_periodo : any = [];
  configuracion = JSON.parse(localStorage.getItem("configuracion"));

  constructor(private crudService: CrudService,
    private notificacion: NotificationsService) { }

  ngOnInit() {
    document.getElementById("catalogos").click();
  }

  asignarLogos(logos) {
    if (logos) {
      this.logo_sucursal = logos.sucursal;
      this.logo_empresa = logos.empresa;
      this.logo_carrera = logos.carrera;
    }
  }
detalle_grupo = []
  cerrar_modal() {
    document.getElementById("detalle-grupo").classList.remove("is-active");
  }
  cerrar_modal_no() {
    document.getElementById("no-grupos").classList.remove("is-active");
  }
  ver_grupo(e,item,ruta){
    console.log(item);
    this.datos_periodo = [];
    
    this.datos_periodo = item;

    if (this.datos_periodo.grupos.length > 0) {
      this.detalle_grupo = this.datos_periodo.grupos;
      console.log('ok');
      document.getElementById("detalle-grupo").classList.add("is-active");
    } else{
      this.detalle_grupo = []
      console.log('no hay grupos');
      document.getElementById("no-grupos").classList.add("is-active");
      
    }
    
  }
}